<template>
  <div class="article-create">
    <ArticleForm />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import ArticleForm from '@/components/Company/ArticleForm';

export default {
  name: 'ArticleCreate',
  metaInfo() {
    return {
      title: this.$t('create'),
    };
  },
  components: {
    ArticleForm,
  },
  setup() {
    return {
      canSeeBlog: ref(process.env.VUE_APP_DEV_TOOLS === 'true'),
    };
  },
};
</script>

<style lang="scss" scoped>
  .article-create {
    background: #F3F3F3;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
</style>

<i18n locale="en" lang="yaml">
create: Create article
</i18n>

<i18n locale="ru" lang="yaml">
create: Создание статьи
</i18n>
